import * as GeneralRepository from "./general-repository";
import * as ContratanteProvider from "../providers/contratante-provider";

export const obtenerContratante = async (idSolicitudMultiple) => {
    const response = await ContratanteProvider.obtenerContratante(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            contratante: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerContratante(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    contratante: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                contratante: null
            }
        }
    }
}

export const guardarContratante = async (contratante, param) => {
    let response = null
    if(contratante.idContratante !== undefined && contratante.idContratante !== null && contratante.idContratante !== 0) {
        let contratanteAux = param === 'firma' ? {
            ...contratante,
            contacto: {
                ...contratante.contacto,
                celular: null
            }
        } : contratante
        response = await ContratanteProvider.actualizarContratante(contratante.idSolicitudMultiple, contratanteAux)
    } else {
        response = await ContratanteProvider.registrarContratante(contratante.idSolicitudMultiple, contratante)
    }
    
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            contratante: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarContratante(contratante)
            } else {
                return {
                    error: response.auditResponse,
                    contratante: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                contratante: null
            }
        }
    }
}